import { Inject, Injectable } from '@angular/core';
import { IMarkupCheckoutService } from './imarkup-checkout.service';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { IonLoaderService, OrderItem } from 'shared';
import { API_CLIENT_SERVICE_IMPL, IAPIClientService } from 'shared';
import { MarkupCheckoutData } from 'projects/shared/src/lib/models/markup-checkout-data';
import { ISetInspectionFailed } from 'pm-src/dtos/i-set-inspection-failed';
import { finalize } from 'rxjs/operators';
import { InspectionData } from 'pm-src/app/models/inspection-data';
import { ApproveOrder } from 'projects/shared/src/lib/models/approve-order';

@Injectable()
export class MarkupCheckoutService implements IMarkupCheckoutService {
    constructor(
        @Inject(API_CLIENT_SERVICE_IMPL) private _apiClient: IAPIClientService,
        private _loaderService: IonLoaderService
    ) {}

    approveCheckout(orderID: number): Observable<HttpResponse<ApproveOrder>> {
        this._loaderService.showLoader();
        return this._apiClient
            .postWithResponse<ApproveOrder>(
                `markup/approveCheckout`,
                orderID,
                new HttpHeaders({
                    'Content-Type': 'application/json',
                })
            )
            .pipe(finalize(() => this._loaderService.hideLoader()));
    }

    getOrderData(orderQrCode: string): Observable<HttpResponse<MarkupCheckoutData>> {
        this._loaderService.showLoader();
        return this._apiClient
            .getWithResponse<MarkupCheckoutData>(`markup/getOrderData/${orderQrCode}`)
            .pipe(finalize(() => this._loaderService.hideLoader()));
    }

    startInspection(orderQrCode: string): Observable<HttpResponse<InspectionData>> {
        this._loaderService.showLoader();
        return this._apiClient
            .postWithResponse<InspectionData>(
                `markup/startInspection`,
                JSON.stringify(orderQrCode),
                new HttpHeaders({
                    'Content-Type': 'application/json',
                })
            )
            .pipe(finalize(() => this._loaderService.hideLoader()));
    }

    closeInspection(orderID: number): Observable<HttpResponse<ApproveOrder>> {
        this._loaderService.showLoader();
        return this._apiClient
            .postWithResponse<ApproveOrder>(
                `markup/closeInspection`,
                orderID,
                new HttpHeaders({
                    'Content-Type': 'application/json',
                })
            )
            .pipe(finalize(() => this._loaderService.hideLoader()));
    }

    requestInspection(orderID: number): Observable<HttpResponse<void>> {
        this._loaderService.showLoader();
        return this._apiClient
            .postWithResponse<void>(
                `markup/requestInspection`,
                orderID,
                new HttpHeaders({
                    'Content-Type': 'application/json',
                })
            )
            .pipe(finalize(() => this._loaderService.hideLoader()));
    }

    setInspectionFailed(
        requestBody: ISetInspectionFailed
    ): Observable<HttpResponse<void>> {
        this._loaderService.showLoader();
        return this._apiClient
            .postWithResponse<void>(`markup/failInspection`, requestBody)
            .pipe(finalize(() => this._loaderService.hideLoader()));
    }
}
